import { makeStyles } from 'tss-react/mui';

const useStylesActionButtonNewItem: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  actionButtonNewItem: {
    width: 'auto',
    height: 'auto',
  },
  actionButtonNewItemNoPadding: {
    padding: '0 !important',
  },
  actionButtonNewItemNoHighlight: {
    '&:hover': {
      background: 'none !important',
    },
  },
  actionButtonNewItemLabel: {
    padding: '3px !important',
    fontSize: '14px !important',
    color: `${theme.palette.common.black} !important`,
    '& > svg': {
      marginRight: 12,
      color: theme.palette.secondary.main,
    },
  },
  actionButtonNewItemTopOffset: {
    marginTop: '20px !important',
  },
  textBlockLight: {
    color: `${theme.palette.common.white} !important`,
  },
  icon: {
    height: 'auto',
  },
}));

export default useStylesActionButtonNewItem;
